import { JS_APIS } from "javascript/jsEngine/constants/enums";

export const JS_EXTERNAL_EVENT_TYPE = "External";

export const VIEWER_VARIATION = "Full";
export const VIEWER_TYPE = "Reader";
export const VIEWER_VERSION = 22.0;
export const FORMS_VERSION = 1.0;
export const LOCALE_TO_LANGUAGE_MAP = {
  "da-DK": "DAN",
  "de-DE": "DEU",
  "en-US": "ENU",
  "en-GB": "ENU",
  "es-ES": "ESP",
  "fi-FI": "SUO",
  "fr-FR": "FRA",
  "it-IT": "ITA",
  "ja-JP": "JPN",
  "nb-NO": "NOR",
  "nl-NL": "NLD",
  "pt-BR": "PTB",
  "sv-SE": "SVE",
  "zh-CN": "CHS",
  "zh-TW": "CHT",
  "ko-KR": "KOR"
};

export const MAX_APIS_TO_LOG_IN_AN_ACTION = 10;
export const MAX_APIS_TO_LOG_IN_PDF_SESSION = 40;
export const UNIMPLEMENTED_PROPERTY = "unimplemented property";

export const JS_DOC_MODIFYING_APIS = [JS_APIS.SET_FIELD, JS_APIS.REMOVE_FIELD, JS_APIS.SET_BASE_URL, JS_APIS.ADD_ICON];

export const JS_VCF_FUNC_NAMES = [
  "AFNumber_Format",
  "AFNumber_Keystroke",
  "AFPercent_Format",
  "AFPercent_Keystroke",
  "AFDate_FormatEx",
  "AFDate_KeystrokeEx",
  "AFDate_Format",
  "AFDate_Keystroke",
  "AFTime_FormatEx",
  "AFTime_KeystrokeEx",
  "AFTime_Format",
  "AFTime_Keystroke",
  "AFSpecial_Format",
  "AFSpecial_Keystroke",
  "AFSpecial_KeystrokeEx",
  "AFSimple",
  "AFMakeNumber",
  "AFSimple_Calculate",
  "AFRange_Validate",
  "AFMergeChange",
  "AFParseDateEx",
  "AFExtractNums"
];
